import {Mapper} from '@s-ui/domain'

export default class ProductRawDataToProductEntityMapper extends Mapper {
  constructor({entity, priceRawDataToPriceVOMapper, taxRawDataToTaxVOMapper}) {
    super()
    this._entity = entity
    this._amountRawDataToAmountVOMapper = priceRawDataToPriceVOMapper
    this._taxRawDataToTaxVOMapper = taxRawDataToTaxVOMapper
  }

  map = ({
    code,
    description,
    discount,
    duration,
    id,
    image,
    price,
    priceBeforeDiscount,
    recommended,
    tax,
    title,
    visibility
  }) => {
    const priceVO = price && this._amountRawDataToAmountVOMapper.map({price})
    const priceBeforeDiscountVO =
      priceBeforeDiscount && this._amountRawDataToAmountVOMapper.map({price: priceBeforeDiscount})
    const taxVO = tax && this._taxRawDataToTaxVOMapper.map({tax})

    return this._entity({
      description,
      discount,
      duration,
      id,
      image,
      name: code,
      price: priceVO?.getPrice?.(),
      priceBeforeDiscount: priceBeforeDiscountVO?.getPrice?.(),
      recommended,
      tax: taxVO?.getTax?.(),
      title,
      visibility
    })
  }
}
